import styles from './ShareButton.module.css';

export default function Notification() {
	return <div className={styles.notification}>Link copiado</div>;
}
